module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cc-steps-bar"
  }, [_vm._l((_vm.steps), function(label, i) {
    return [_c('div', {
      key: 'step-' + i,
      class: ['cc-step', _vm.stepStatus(i)]
    }, [_c('div', {
      staticClass: "cc-step-circle"
    }, [_vm._v(_vm._s(_vm.stepStatus(i) === 'done' ? '✓' : i + 1))]), _vm._v(" "), _c('div', {
      staticClass: "cc-step-lbl"
    }, [_vm._v(_vm._s(label))])]), _vm._v(" "), (i < _vm.steps.length - 1) ? _c('div', {
      key: 'line-' + i,
      class: ['cc-step-line', {
        done: i + 1 < _vm.currentStep
      }]
    }) : _vm._e()]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-25dc126c","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nudge-console/create-campaign/CampaignStepsBar.vue
// module id = KCz2
// module chunks = 1